import { cva, type VariantProps } from 'class-variance-authority';
import type { FC } from 'react';
import { cn } from '../lib/utils';

/** The two chevrons of the Ziggiz mark, without the cap. */
const CHEVRONS = [
  'M88.2966 170.421L118.804 200.882L149.277 231.377L179.784 200.882L210.257 170.421L240.764 139.926L210.257 109.465L179.784 78.9693V139.926L149.277 170.421L118.804 139.926V78.9693L88.2966 109.465L57.7896 139.926L88.2966 170.421Z',
  'M271.238 170.421L240.731 139.926V200.882L210.224 231.377L179.717 261.873L149.21 292.368L118.703 261.873L88.1955 231.377L57.6885 200.882V139.926L27.1815 170.421L2.34147 195.251C-0.780491 198.372 -0.780491 203.426 2.34147 206.513L27.1815 231.344L57.6885 261.839L88.1955 292.334L118.703 322.829L143.543 347.659C146.665 350.78 151.721 350.78 154.809 347.659L179.649 322.829L210.156 292.334L240.663 261.839L271.17 231.344L296.146 206.377C299.2 203.325 299.2 198.406 296.146 195.353L271.17 170.387L271.238 170.421Z'
] as const;

export const assistantMarkVariants = cva(
  'inline-flex shrink-0 items-center justify-center rounded-full bg-primary text-[color:var(--z-on-brand)]',
  {
    variants: {
      size: {
        sm: 'size-7 [&_svg]:size-3.5',
        default: 'size-8 shadow-brand [&_svg]:size-[17px]'
      }
    },
    defaultVariants: { size: 'default' }
  }
);

interface AssistantMarkProps extends VariantProps<typeof assistantMarkVariants> {
  className?: string;
}

/** The Assistant's avatar: the mark's chevrons on a glowing brand disc. */
export const AssistantMark: FC<AssistantMarkProps> = ({ size, className }) => (
  <span aria-hidden="true" className={cn(assistantMarkVariants({ size }), className)}>
    <svg viewBox="0 40 299 320" fill="currentColor">
      {CHEVRONS.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  </span>
);
